import React from 'react';

function LandingPage({ onStart }) {
  return (
    <div className="landing-page">
      <div className="container">
        <div className="hero">
          <h1 className="title">Discover Your Planning DNA</h1>
          <p className="subtitle">Make Any Planner Work for You</p>
          
          <div className="value-prop">
            <p className="lead-text">
              Free 5-minute assessment reveals your unique planning style
            </p>
            
            <div className="benefits">
              <div className="benefit">
                <span className="icon">✓</span>
                <span>Discover why previous planners failed you</span>
              </div>
              <div className="benefit">
                <span className="icon">✓</span>
                <span>Get personalized strategies you can use today</span>
              </div>
              <div className="benefit">
                <span className="icon">✓</span>
                <span>Learn which planning tools match your brain</span>
              </div>
            </div>
          </div>

          <button 
            className="cta-button" 
            onClick={onStart}
          >
            Start Your Free Assessment
          </button>

          <p className="trust-text">
            Join thousands who've discovered their Planning DNA
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
